import Vue from "vue";
import VueRouter from "vue-router";
import LoginView from "../views/LoginView.vue";
import DisponibilidadView from "../views/DisponibilidadView.vue";
import HomeView from "../views/HomeView.vue";
import ColaboradoresView from "../views/ColaboradoresView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "login",
    component: LoginView,
    meta: { isPublic: true },
  },
  {
    path: "/inicio",
    name: "inicio",
    component: HomeView,
    meta: { requiresAuth: true },
  },
  {
    path: "/disponibilidad",
    name: "disponibilidad",
    component: DisponibilidadView,
    meta: { requiresAuth: false },
  },
  {
    path: "/cumpleanos",
    redirect: "/inicio",
  },
  {
    path: "/colaboradores",
    name: "colaboradores",
    component: ColaboradoresView,
    meta: { requiresAuth: true },
  },
  {
    path: "*",
    redirect: "/",
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach((to, from, next) => {
  let usuario = null;
  const rawSession = sessionStorage.getItem("usuario");
  const rawLocal = localStorage.getItem("usuario");
  try {
    usuario = JSON.parse(rawSession || rawLocal);
  } catch (e) {
    usuario = null;
  }
  if (to.meta.requiresAuth && !usuario) {
    return next("/");
  }
  if (to.meta.rolesPermitidos && usuario) {
    const rol = (usuario.rol || "").trim().toLowerCase();
    const permitidos = (to.meta.rolesPermitidos || []).map((r) => String(r).trim().toLowerCase());
    if (!permitidos.includes(rol)) {
      return next("/inicio");
    }
  }
  next();
});

export default router;
